import { useState } from 'react';

import FeedbackButton from '@helsenorge/core-cms/feedbackbutton';
import FeedbackPanel from '@helsenorge/core-cms/feedbackpanel';
import type { SurveyDto } from '@helsenorge/framework-utils/additional-page-content';

import styles from './styles.module.scss';

interface FeedbackPanelWrapperProps {
  survey: SurveyDto;
  variant: 'static' | 'expander';
  onClose: (id: string) => void;
}

const FeedbackPanelWrapper: React.FC<FeedbackPanelWrapperProps> = props => {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = (id: string): void => {
    setIsVisible(false);
    props.onClose(id);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <FeedbackPanel
      title={props.survey.title}
      variant={props.variant}
      closeButtonText={props.survey.closeButtonText}
      onClose={() => handleClose(props.survey.id)}
      buttons={
        <>
          <FeedbackButton variant="outline" onClick={() => handleClose(props.survey.id)} href={props.survey.surveyUrl} htmlMarkup="a">
            {props.survey.acceptButtonText}
          </FeedbackButton>
          <FeedbackButton variant="borderless" onClick={() => handleClose(props.survey.id)}>
            {props.survey.declineButtonText}
          </FeedbackButton>
        </>
      }
    >
      {props.survey.text}

      {props.survey.disclaimerText && (
        <p className={styles.disclaimertext}>{props.survey.disclaimerText.replace('{url}', props.survey.surveyUrl)}</p>
      )}
    </FeedbackPanel>
  );
};

export default FeedbackPanelWrapper;
